<template>
	<v-sheet :loading="loading">
		<table class="form">
			<colgroup>
				<col width="20%" />
				<col width="80%" />
			</colgroup>

			<tr>
				<th>
					회원상태
					<v-icon
						color="info"
						small
						@click="dialog.state_hint = true"
					>
						mdi-help-circle
					</v-icon>
				</th>
				<td>
					<form @submit.prevent="putState">
						<label>
							<input
								v-model="qna_register_state.state"
								type="radio"
								value="정상"
							/>
							정상
						</label>

						<label class="ml-3">
							<input
								v-model="qna_register_state.state"
								type="radio"
								value="정지"
							/>
							이용정지
						</label>
						<input-date
							v-model="qna_register_state.start"
							readonly
							:disabled="'정지' != qna_register_state.state"
						/>
						~
						<input-date
							v-model="qna_register_state.end"
							required
							:disabled="'정지' != qna_register_state.state"
						/>

						<label class="ml-3">
							<input
								v-model="qna_register_state.state"
								type="radio"
								value="차단"
							/>
							이용차단 & Q&A 전체 게시글 자동 차단
						</label>

						<v-btn type="submit" small color="info" class="ml-5"
							>저장</v-btn
						>
					</form>
				</td>
			</tr>

			<tr>
				<th>처리내역</th>
				<td>
					<v-btn small @click="dialog.invalid_report = true"
						>오신고: {{ invalid_report.totalCount }}건</v-btn
					>
					<v-btn small class="ml-2" @click="dialog.stop_block = true"
						>정지: {{ state.stopCount }}건 / 차단:
						{{ state.blockCount }}건</v-btn
					>
				</td>
			</tr>
		</table>

		<v-dialog v-model="dialog.state_hint" max-width="600">
			<v-sheet>
				<pre class="pa-5">
Q&A 서비스에서 회원 활동을 제한하는 기능입니다.

<b class="info--text">정상</b>
현재 서비스 이용에 제한이 없는 상태입니다.

<b class="warning--text">이용정지</b>
- 이용정지 기간은 이용정지 설정일 기준으로 계산 됩니다.
(ex. 5/1 12:30분에 이용정지 7일 → 5/8 00:00에 이용정지 해제)
- 이용정지 기간동안 뷰잉을 제외한 모든 활동은 제한됩니다.
- 작성한 게시글은 차단되지 않습니다.

<b class="error--text">이용차단</b>
- 운영자가 이용해제 전까지 뷰잉을 제외한 모든 활동은 제한됩니다.
- 작성한 전체 게시글은 자동 차단됩니다.

<hr/>
<b class="info--text">이용정지/이용차단시 활동 제한되는 영역</b>
- 질문/답변/댓글 작성, 수정 불가
- 질문/답변/댓글 좋아요, 좋아요취소 불가
- 질문/답변/댓글 신고 불가
</pre>
			</v-sheet>
		</v-dialog>

		<v-dialog
			v-model="dialog.invalid_report"
			max-width="800"
			scrollable
			@keydown.esc="dialog.invalid_report = false"
			@click:outside="dialog.invalid_report = false"
		>
			<v-sheet>
				<table class="list">
					<tr>
						<th>처리일시</th>
						<th>신고유형</th>
						<th>상태</th>
						<th>신고번호</th>
					</tr>

					<tr
						v-for="report in invalid_report.qnaReportList"
						:key="report.id"
					>
						<td>
							{{
								report.createdAt | dateFormat('YY.MM.DD HH:mm')
							}}
						</td>
						<td>{{ REPORT_TYPE_LABEL[getReportType(report)] }}</td>
						<td>오신고처리</td>
						<td>
							<router-link
								:to="`/qna/${getReportType(report)}/report/${report.id}`"
								target="_blank"
							>
								{{ report.id }}
							</router-link>
						</td>
					</tr>
				</table>
			</v-sheet>
		</v-dialog>

		<v-dialog
			v-model="dialog.stop_block"
			max-width="800"
			scrollable
			@keydown.esc="dialog.stop_block = false"
			@click:outside="dialog.stop_block = false"
		>
			<v-sheet>
				<table class="list">
					<tr>
						<th>처리일시</th>
						<th>회원상태</th>
						<th>적용기간</th>
					</tr>

					<tr
						v-for="qr_state in state.qnaRegisterStateList"
						:key="qr_state.id"
					>
						<td>
							{{
								qr_state.createdAt
									| dateFormat('YY.MM.DD HH:mm')
							}}
						</td>
						<td>{{ qr_state.state }}</td>
						<td>
							{{ qr_state.createdAt | dateFormat('YY.MM.DD') }} ~
							<span v-if="qr_state.expiredAt">{{
								qr_state.expiredAt | dateFormat('YY.MM.DD')
							}}</span>
						</td>
					</tr>
				</table>
			</v-sheet>
		</v-dialog>
	</v-sheet>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import Util from '@/lib/Util';
	import InputDate from '@/components/InputDate';

	const REPORT_TYPE_LABEL = {
		qna: '질문',
		reply: '답변',
		comment: '댓글',
		register: '작성자',
	};

	export default {
		components: {
			InputDate,
		},

		data() {
			return {
				loading: false,
				register_id: this.$route.params.idRegister,
				state: {
					qnaRegisterStateList: [],
				},
				invalid_report: {},
				qna_register_state: {
					state: '정상',
					start: moment().format('YYYY-MM-DD'),
				},

				dialog: {
					state_hint: false,
					invalid_report: false,
					stop_block: false,
				},

				REPORT_TYPE_LABEL,
			};
		},

		computed: {},

		created() {},

		async mounted() {
			await this.load();
		},

		methods: {
			async load() {
				this.loading = true;
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/qna/register/${this.register_id}/state`
					);
					this.state = data;
					this.state.qnaRegisterStateList = _.reverse(
						data.qnaRegisterStateList
					);
					const last = this.state.qnaRegisterStateList[0];
					if (
						last &&
						(new Date(last.expiredAt) > new Date() ||
							!last.expiredAt)
					) {
						this.qna_register_state.state = last.state;
						this.qna_register_state.end = last.expiredAt
							? moment(last.expiredAt).format('YYYY-MM-DD')
							: undefined;
					}
					const rs = await this.$axiosAdmin2.get(
						`/api/qna/register/${this.register_id}/invalid-report`
					);
					this.invalid_report = rs.data;
				} catch (e) {
					Util.error(e);
				} finally {
					this.loading = false;
				}
			},

			async putState() {
				this.loading = true;
				try {
					const payload = { state: this.qna_register_state.state };
					if ('정지' == payload.state) {
						payload.expiredAt = moment(
							this.qna_register_state.end,
							'YYYY-MM-DD'
						)
							.endOf('date')
							.format('x');
					}
					await this.$axiosAdmin2.put(
						`/api/qna/register/${this.register_id}/state`,
						payload
					);
					await this.load();
				} catch (e) {
					Util.error(e);
				} finally {
					this.loading = false;
				}
			},

			getReportType(report) {
				if ('qna_reply' == report.refType) {
					if (report.qnaReply.parentId) {
						return 'c';
					}
					return 'a';
				}
				return 'q';
			},
		},
	};
</script>
